// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__kMmq3","colMin":"styles_colMin__1UhPQ","colCheckbox":"styles_colCheckbox__twvzY"};